export default __webpack_public_path__ + "static/media/how-to-resize-an-image.ee348920.png";